// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.moles[data-v-74052938] {

    display: flex;

    width: 100%;

    align-items: flex-end
}
.moles__wrapper[data-v-74052938] {

    position: relative
}
.moles__wrapper.vertical[data-v-74052938] {

    height: 100%
}
.moles.center[data-v-74052938] {

    justify-content: center
}
.moles.left[data-v-74052938] {

    justify-content: flex-end
}
.moles.right[data-v-74052938] {

    justify-content: flex-start
}
.moles.justify[data-v-74052938] {

    justify-content: space-between
}
.moles.warning[data-v-74052938] {

    --tw-bg-opacity: 1;

    background-color: rgb(247 210 81 / var(--tw-bg-opacity))
}
.moles.info[data-v-74052938] {

    --tw-bg-opacity: 1;

    background-color: rgb(0 154 250 / var(--tw-bg-opacity))
}
.moles.error[data-v-74052938] {

    --tw-bg-opacity: 1;

    background-color: rgb(255 141 110 / var(--tw-bg-opacity))
}
.moles.success[data-v-74052938] {

    --tw-bg-opacity: 1;

    background-color: rgb(12 193 117 / var(--tw-bg-opacity))
}
.moles.transparent[data-v-74052938] {

    background-color: transparent !important
}
.vertical .moles[data-v-74052938] {

    height: 100%;

    flex-direction: column
}
.moles__icon[data-v-74052938] {

    position: absolute;

    bottom: -4rem;

    z-index: 10;

    margin-left: auto;

    margin-right: auto;

    display: flex;

    width: 17rem;

    justify-content: center;

    border-radius: 22px;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    padding-top: 2rem;

    padding-bottom: 2rem;

    --tw-shadow: 0px 12.46px 15.23px rgba(0,0,0,0.08);

    --tw-shadow-colored: 0px 12.46px 15.23px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/layout/Moles.vue"],"names":[],"mappings":";AA0FA;;IAAA,aAAA;;IAAA,WAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAIA;;IAAA,YAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,WAAA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,YAAA;;IAAA,uBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,iDAAA;;IAAA,+DAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"moles__wrapper\" :class=\"{ vertical }\">\n    <div class=\"moles\" :class=\"[ type, align, background ]\" :style=\"style\">\n      <div v-if=\"icon\" class=\"moles__icon\">\n        <Icon :name=\"icon\" :size=\"iconSize\" :color=\"iconColor\" type=\"stroke\" />\n      </div>\n      <Mole\n        v-for=\"index in count\"\n        v-bind:key=\"index\"\n        :type=\"type\"\n        :spacing=\"spacing\"\n        :reversed=\"!!(index % 2) != reversed\"\n        :vertical=\"vertical\"\n        :scale=\"scale\"\n      ></Mole>\n    </div>\n  </div>\n</template>\n\n<script>\nimport Mole from '@/lego/components/layout/Mole.vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nexport default {\n  components: {\n    Mole,\n    Icon,\n  },\n  props: {\n    type: {\n      type: String,\n      default: 'warning',\n    },\n    background: {\n      type: String,\n      default: 'warning',\n    },\n    spacing: {\n      type: String,\n      default: 'sm',\n    },\n    count: {\n      type: Number,\n      default: 4,\n    },\n    align: {\n      type: String,\n      default: 'center',\n    },\n    scale: {\n      type: Number,\n      default: 1,\n    },\n    reversed: {\n      type: Boolean,\n      default: false,\n    },\n    position: {\n      type: String,\n      default: 'initial',\n    },\n    vertical: {\n      type: Boolean,\n      default: false,\n    },\n    icon: {\n      type: String,\n      default: null,\n    },\n    iconSize: {\n      type: Number,\n      default: 80,\n    },\n    iconColor: {\n      type: String,\n      default: 'black',\n    },\n  },\n  setup(props) {\n    const style = 'position: ' + props.position + ';' + (!!props.icon ? 'margin-bottom: 4rem;' : '');\n\n    return {\n      style,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.moles {\n  @apply flex items-end w-full;\n\n  &__wrapper {\n    @apply relative;\n\n    &.vertical {\n      @apply h-full;\n    }\n  }\n\n  &.center {\n    @apply justify-center;\n  }\n  &.left {\n    @apply justify-end;\n  }\n  &.right {\n    @apply justify-start;\n  }\n  &.justify {\n    @apply justify-between;\n  }\n\n  &.warning {\n    @apply bg-feedback-alert-medium;\n  }\n  &.info {\n    @apply bg-support-dark;\n  }\n  &.error {\n    @apply bg-feedback-error-light;\n  }\n  &.success {\n    @apply bg-feedback-success-medium;\n  }\n  &.transparent {\n    @apply !bg-transparent;\n  }\n\n  .vertical & {\n    @apply flex-col h-full;\n  }\n\n  &__icon {\n    @apply absolute -bottom-xl mx-auto flex justify-center w-[17rem] py-xs bg-neutral-white rounded-[22px] z-10 shadow-[0px_12.46px_15.23px_rgba(0,0,0,0.08)];\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
